export default async () => {
  await create({
    element: 'login',
    full: true,
    branding: dic?.branding || {}
  });
};
